<template>
  <div>
    <v-dialog
      v-model="dialog"
      @keydown.esc="dialog = false"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-form ref="form" lazy-validation>
          <v-card-title>
            <span class="headline">{{ $t("restore") }} {{ $t("system") }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-file-input
                    v-model="systemData.file"
                    :label="$t('config') + ' ' + $t('file').toLowerCase() + '*'"
                    :rules="rules.required"
                    accept=".zip"
                    show-size
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>

            <small>*{{ $t("indicates-required-field") }}</small>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="dialog = false">
              {{ $t("close") }}
            </v-btn>

            <v-btn
              color="primary"
              text
              @click="$refs.restoreConfirmDialog.dialog = true"
            >
              {{ $t("restore") }}
            </v-btn>

            <ConfirmDialog
              ref="restoreConfirmDialog"
              :repeatString="'restore'"
              @doFunction="restoreSystem"
            ></ConfirmDialog>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfirmDialog from "@/components/base/ConfirmDialog.vue";

import { restoreSystem } from "@/endpoint/system";

export default {
  name: "SystemRestoreDialog",
  components: { ConfirmDialog },
  props: {
    isRefresh: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
      rules: {
        required: [(v) => !!v || this.$t("rule-required")],
      },
      systemData: {
        file: null,
      },
    };
  },
  methods: {
    restoreSystem() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const data = new FormData();
      data.append("file", this.systemData.file);

      this.$store.dispatch("openOverlay");

      restoreSystem(data)
        .then(() => {
          this.$store.dispatch("closeOverlay");
          this.dialog = false;
          this.$emit("restart");
        })
        .catch(() => {
          this.$store.dispatch("closeOverlay");
        });
    },
  },
};
</script>